import { render, staticRenderFns } from "./ninja.vue?vue&type=template&id=a144444a&scoped=true&"
import script from "./ninja.vue?vue&type=script&lang=js&"
export * from "./ninja.vue?vue&type=script&lang=js&"
import style0 from "./ninja.vue?vue&type=style&index=0&id=a144444a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a144444a",
  null
  
)

export default component.exports